import React from 'react';
import styled from 'styled-components';

import { Tab } from '@lt/components';

import { SEARCH_TYPE_NAMES } from 'src/constants/search';
import type { SearchType } from '../../types/search';

import { getStyles } from './utils';
import type { TabsVariant } from './types';
import {
  SEARCH_TAB_EXCURSIONS_DATA_TEST_ID,
  SEARCH_TAB_HOTELS_DATA_TEST_ID,
  SEARCH_TAB_TOURS_DATA_TEST_ID,
  TABS_PAGES,
} from './constants';

interface SearchTypeTabProps {
  name: SearchType;
  label: string;
  altLabel?: string;
  Icon: React.MemoExoticComponent<
    (props: React.SVGProps<SVGSVGElement>) => JSX.Element
  >;
  isActive?: boolean;
  variant: TabsVariant;
  onClick?: () => null;
}

const DATA_TEST_ID_MAP = {
  [SEARCH_TYPE_NAMES.PACKAGE]: SEARCH_TAB_TOURS_DATA_TEST_ID,
  [SEARCH_TYPE_NAMES.HOTEL]: SEARCH_TAB_HOTELS_DATA_TEST_ID,
  [SEARCH_TYPE_NAMES.TRIP]: SEARCH_TAB_EXCURSIONS_DATA_TEST_ID,
};

export const SearchTypeTab = ({
  name,
  label,
  altLabel,
  Icon,
  isActive,
  variant,
  onClick,
}: SearchTypeTabProps) => {
  const { mobile, page, collapsed } = variant;

  const StyledIcon = styled(Icon)<{
    $variant: TabsVariant;
    $isActive?: boolean;
  }>`
    width: 24px;
    height: 24px;
    margin-right: 4px;
    flex: 1;

    path {
      ${({ $variant, $isActive }) => getStyles('ICON', $variant, $isActive)}
    }
  `;
  const dataTestId = DATA_TEST_ID_MAP[name];

  return (
    <StyledTab
      onClick={onClick}
      value={name}
      $variant={variant}
      $isActive={isActive}
      data-testid={dataTestId}
    >
      {collapsed && mobile ? null : (
        <StyledIcon $variant={variant} $isActive={isActive} />
      )}
      <span>{page === 'HOTEL' ? altLabel || label : label}</span>
    </StyledTab>
  );
};

const StyledTab = styled(Tab).attrs({ functional: true })<{
  $variant: TabsVariant;
  $isActive?: boolean;
}>`
  cursor: pointer;
  padding: ${({ $variant: { mobile, page } }) =>
    !mobile && page === TABS_PAGES.MAIN ? '8px 22px' : '8px 16px'};
  border: none;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: var(--border-radius);

  ${({ $variant, $isActive }) => getStyles('TAB', $variant, $isActive)}

  button {
    display: flex;
    align-items: center;
    background: inherit;
    color: inherit;

    @media (max-width: 390px) {
      &:last-child {
        padding: 0;
      }
    }
  }
  ${({ name }) => name === 'hotel' && 'display: flex'}
  @media (max-width: 390px) {
    padding: 7px 12px 7px 8px;
  }
  @media (max-width: 320px) {
    padding: 6px 8px;
  }
`;

export const StyledNewIcon = styled.div`
  font-weight: 50;
  letter-spacing: 0.1em;
  margin-left: 4px;
  font-size: 8px;
  color: white;
  background: linear-gradient(90deg, #ff9c41 0%, #f82c69 100%);
  border-radius: 4px;
  padding: 4px;
`;
